import React, { useEffect, useState } from "react";
import LoginBox from "../../components/Auth/LoginBox/LoginBox";
import LoginLeftPanel from "../../components/Genericos/LoginLeftPanel/LoginLeftPanel";
import { Network } from "@capacitor/network";
import "./LoginStyle.css";
import MantenimientoCard from "../../components/Genericos/MantenimientoCard/MantenimientoCard";
import SinRed from "_+_Portal/components/Genericos/SinRed/SinRed";
import { motion } from "framer-motion";
import { pageContainerVariants } from "global/utils/cardAnimation";

const Layout = ({
  error,
  form,
  onChange,
  onSubmit,
  loginFormValid,
  loading,
  onClickSocialHandler,
  onClickRegister,
  onClickChangePassword,
  responseFacebook,
  biometricAvailable,
  biometricEnabled,
  biometricLoading,
  biometryTypeName,
  lastBiometricUser,
  onBiometricLogin,
}) => {
  const [flgBox, setFlgBox] = useState(false);
  const [network, setNetwwork] = useState(true);
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;
  
  //configuracion de portal en mantenimiento, al json lo lee de la carpeta public
  useEffect(() => {
    setFlgBox(true);
  }, []);

  let config = localStorage.getItem("config");
  let mantenimiento = JSON.parse(config).mantenimiento;

  useEffect(() => {
    Network.getStatus().then((status) => {
      setNetwwork(status.connected);
    });

    Network.addListener("networkStatusChange", (status) => {
      let config = localStorage.getItem("config");
      config = JSON.parse(config);
      const dtoMantenimiento = {
        mantenimiento: false,
        mantenimientoMsj:
          "El portal se encuentra momentaneamente en mantenimiento. Por favor, intente nuevamente en unos minutos",
      };
      config = { ...config, ...dtoMantenimiento };
      localStorage.setItem("config", JSON.stringify(config));
      setNetwwork(status.connected);
    });
  }, []);

  return (
    <React.Fragment>
      <div className="loginContainer">
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 0 }}
          transition={{ duration: 0.4 }}
          className="leftpanel-motion"
        >
          <div className="ptur-login-leftpanel">
            <LoginLeftPanel />
          </div>
        </motion.div>
        <motion.div
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className="rightpanel-motion"
        >
          <div className="ptur-login-righpanel">
            {flgBox &&
              (mantenimiento || !network ? (
                !network ? (
                  <SinRed />
                ) : mantenimiento ? (
                  <MantenimientoCard />
                ) : (
                  <></>
                )
              ) : (
                <LoginBox
                  form={form}
                  onChange={onChange}
                  onSubmit={onSubmit}
                  loginFormValid={loginFormValid}
                  onClickSocialHandler={onClickSocialHandler}
                  responseFacebook={responseFacebook}
                  onClickRegister={onClickRegister}
                  onClickChangePassword={onClickChangePassword}
                  loading={loading}
                  error={error}
                  biometricAvailable={biometricAvailable}
                  biometricEnabled={biometricEnabled}
                  biometricLoading={biometricLoading}
                  biometryTypeName={biometryTypeName}
                  lastBiometricUser={lastBiometricUser}
                  onBiometricLogin={onBiometricLogin}
                />
              ))}
          </div>
        </motion.div>
      </div>
    </React.Fragment>
  );
};

export default Layout;
